import { ReactElement } from 'react'

const FORWARD_REF_TYPE = Symbol.for('react.forward_ref')

const canAcceptRef = (element: ReactElement): boolean => {
  const { type } = element

  // DOM elements like 'div', 'button'
  if (typeof type === 'string') {
    return true
  }

  // forwardRef components
  if (
    typeof type === 'object' &&
    type !== null &&
    '$$typeof' in type &&
    (type as { $$typeof: symbol }).$$typeof === FORWARD_REF_TYPE
  ) {
    return true
  }

  return false
}

export { canAcceptRef }
